/**
 * Photographers whose work appears on NyumbaSuite.
 *
 * GENERATED by scripts/house-covers.mjs. Do not edit by hand.
 *
 * Empty, and that is the finished state rather than a gap: every cover on the
 * site is now NyumbaSuite's own photography, so no outside licence asks for a
 * credit. SiteFooter renders nothing when this list is empty.
 *
 * If a Pexels photograph is ever used again, scripts/blog-covers.mjs rewrites
 * this file with the names that licence requires, and the line comes back.
 */

export interface PhotoCredit {
  name: string;
  /** The photographer's own page, which is what a licence asks to link. */
  profile: string;
}

export const PHOTO_CREDITS: PhotoCredit[] = [];

export const PHOTO_SOURCE = { name: 'Pexels', url: 'https://www.pexels.com' };
